import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { MeetingModalSharedComponent } from './meeting-modal-shared.component';

@NgModule({
  declarations: [MeetingModalSharedComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  exports: [MeetingModalSharedComponent],
})
export class SharedMeetingModalModule {}
